module.exports = __webpack_public_path__ + "static/media/close.6858ace9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/close.svg
// module id = 27
// module chunks = 0